import { useEffect } from 'react';
import { isNil } from 'ramda';
import { ControlledRadioButton } from '@@viewCommonComponents/controlled';

const convertBudgetFromLegacyFormat = (budget) => {
  const mapping = {
    '<50': 'LESS_THAN_50',
    '50<>99': 'BETWEEN_50_AND_99',
    '100<>149': 'BETWEEN_100_AND_149',
    '150<>199': 'BETWEEN_150_AND_199',
    '>200': 'MORE_THAN_200'
  };
  return mapping[budget] || budget;
};

const SimulationNeedsExtraForm = ({ form }) => {

  useEffect(() => {
    const budget = form.watch('collectionNeeds.0.budget');

    if (isNil(budget)) {
      form.setValue('collectionNeeds.0.budget', 'LESS_THAN_50');
    } else {
      const convertedBudget = convertBudgetFromLegacyFormat(budget);
      if (convertedBudget !== budget) {
        form.setValue('collectionNeeds.0.budget', convertedBudget);
      }
    }
  }, [form]);

  const availableBudgets = [
    { label: 'Moins de 50 euros', value: 'LESS_THAN_50' },
    { label: 'de 50 à 99 euros', value: 'BETWEEN_50_AND_99' },
    { label: 'de 100 à 149 euros', value: 'BETWEEN_100_AND_149' },
    { label: 'de 150 à 199 euros', value: 'BETWEEN_150_AND_199' },
    { label: '200 euros et plus', value: 'MORE_THAN_200' }
  ];

  return (
    <>
      <ControlledRadioButton
        label="Quel budget souhaitez-vous consacrer à votre complémentaire santé ?"
        name="collectionNeeds.0.budget"
        options={availableBudgets}
        form={form}
        isResponsiveCol
        isMultiline
      />
    </>
  );
};

export default SimulationNeedsExtraForm;
